import { jsxs as b, jsx as n } from "react/jsx-runtime";
import { Box as I, Autocomplete as w, TextField as x, Button as C, Alert as O } from "@mui/material";
import { useState as r } from "react";
import P from "@mui/icons-material/Search";
import D from "@mui/icons-material/Login";
import { C as N } from "../../index-D7cgykJH.js";
const W = ({ onSchoolSelected: d }) => {
  const [h, p] = r([]), [u, i] = r(!1), [s, l] = r((N.isNativePlatform(), null)), [m, a] = r(null), f = async (o) => {
    i(!0);
    const t = {
      method: "POST",
      body: JSON.stringify({ searchterm: o })
    }, e = await (await fetch("https://daymapschools.azurewebsites.net/api/Schools", t)).json();
    p(e), i(!1), a(null);
  }, S = async (o) => {
    const t = {
      method: "POST",
      body: JSON.stringify({ schoolname: o })
    }, e = await (await fetch("https://daymapschools.azurewebsites.net/api/Schools", t)).json();
    if (!e[0] || !e[0].SchoolCode) {
      l(null), a(o);
      return;
    }
    const c = new URL(e[0].Daymap), y = {
      schoolCode: e[0].SchoolCode,
      schoolName: o,
      identityUrl: e[0].IDServer,
      baseUrl: `${c.protocol}//${c.hostname}`
    };
    l(y), a(o);
  };
  return /* @__PURE__ */ b(I, { display: "flex", flexDirection: "column", gap: 2, alignItems: "center", sx: { maxWidth: "20em", width: "100%" }, children: [
    /* @__PURE__ */ n(
      w,
      {
        fullWidth: !0,
        filterOptions: (o) => o,
        freeSolo: !0,
        disableClearable: !0,
        options: h || [],
        onInputChange: (o, t) => f(t),
        onChange: (o, t) => S(t),
        loading: u,
        renderInput: (o) => /* @__PURE__ */ n(
          x,
          {
            ...o,
            label: "Search",
            variant: "outlined",
            slotProps: {
              ...o.InputProps,
              input: {
                ...o.InputProps,
                startAdornment: /* @__PURE__ */ n(P, {})
              }
            }
          }
        )
      }
    ),
    /* @__PURE__ */ n(C, { fullWidth: !0, onClick: () => {
      s && d(s);
    }, variant: "contained", disabled: !s, startIcon: /* @__PURE__ */ n(D, {}), children: "Sign In" }),
    !s && m && /* @__PURE__ */ n(O, { severity: "warning", children: "This school has not been configured to use Daymap Mobile" })
  ] });
};
export {
  W as SchoolSearch
};
//# sourceMappingURL=index.js.map
